import type { CatchResponse, SpotCatchSummary, ClubCatchResponse } from '../../types/api';

export interface CatchRow {
  id: string;
  fishTypeName: string;
  lureTypeName?: string | null;
  anglerName?: string | null;
  spotName?: string | null;
  lengthInches?: number | null;
  caughtAt: string;
  sessionId?: number | null;
}

export function fromCatchResponse(c: CatchResponse): CatchRow {
  return {
    id: c.id,
    fishTypeName: c.fishTypeName,
    lureTypeName: c.lureTypeName,
    anglerName: c.userDisplayName,
    spotName: c.spotName,
    lengthInches: c.lengthInches,
    caughtAt: c.caughtAt,
    sessionId: c.sessionId,
  };
}

export function fromSpotCatchSummary(c: SpotCatchSummary): CatchRow {
  return {
    id: c.id,
    fishTypeName: c.fishTypeName,
    lureTypeName: c.lureTypeName,
    anglerName: c.anglerDisplayName,
    spotName: null,
    lengthInches: c.lengthInches,
    caughtAt: c.caughtAt,
    sessionId: null,
  };
}

export function fromClubCatchResponse(c: ClubCatchResponse): CatchRow {
  return {
    id: c.id,
    fishTypeName: c.fishTypeName,
    lureTypeName: c.lureTypeName,
    anglerName: c.anglerDisplayName,
    spotName: c.spotName,
    lengthInches: c.lengthInches,
    caughtAt: c.caughtAt,
    sessionId: null,
  };
}
